"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var helpers_1 = require("./helpers");
var Tooltip_1 = require("../../Tooltip");
var Text_1 = require("../../Text");
var Grid_1 = require("./..");
exports.textWrapId = 'grid-text-wrap';
var getTextAlign = function (headerJustify) {
    switch (headerJustify) {
        case Grid_1.GRID_COLUMN_HEADER_JUSTIFY.left:
            return Text_1.TEXT_ALIGN.left;
        case Grid_1.GRID_COLUMN_HEADER_JUSTIFY.center:
            return Text_1.TEXT_ALIGN.center;
        case Grid_1.GRID_COLUMN_HEADER_JUSTIFY.right:
            return Text_1.TEXT_ALIGN.right;
        default:
            return undefined;
    }
};
exports.Cell = function (_a) {
    var cellData = _a.cellData, columnWidth = _a.columnWidth, bold = _a.bold, contentJustify = _a.contentJustify, tooltipMaxWidth = _a.tooltipMaxWidth;
    var ref = react_1.useRef(null);
    return Tooltip_1.useTooltip({
        delayTimeout: 500,
        maxWidth: tooltipMaxWidth || columnWidth + 50 + "px",
        renderContent: function () { return react_1.default.createElement(helpers_1.TooltipText, { size: Text_1.TEXT_SIZE.s }, cellData); },
        render: function (tooltipProps) {
            return (react_1.default.createElement(Text_1.Text, __assign({}, tooltipProps, { ref: ref, "data-selector-id": exports.textWrapId, truncate: true, view: Text_1.TEXT_VIEW.inherit, weight: bold ? Text_1.TEXT_WEIGHT.bold : Text_1.TEXT_WEIGHT.normal, onMouseEnter: helpers_1.onMouseEnterHandlerDecorator(tooltipProps.onMouseEnter, ref), align: getTextAlign(contentJustify) }), cellData));
        }
    });
};
exports.trimmedTextRenderer = function (_a) {
    var cellData = _a.cellData, columnWidth = _a.columnWidth, bold = _a.bold, disabled = _a.disabled, inactive = _a.inactive, headerJustify = _a.headerJustify, tooltipMaxWidth = _a.tooltipMaxWidth;
    if (cellData && columnWidth) {
        return (react_1.default.createElement(exports.Cell, { cellData: cellData, columnWidth: columnWidth, bold: bold, disabled: disabled, inactive: inactive, contentJustify: headerJustify, tooltipMaxWidth: tooltipMaxWidth }));
    }
    return null;
};
//# sourceMappingURL=trimmedTextRenderer.js.map